module.exports = __webpack_public_path__ + "img/nabl_gallery12.dc63c188.jpg";